import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

interface RangeModel {
  numerator: { min: number; max: number }
  denominator: { min: number; max: number }
  variation: number
}

interface DifficultyLevelRangeMapModel {
  [key: number]: RangeModel
}

export interface FractionModel {
  quotient: number
  numerator: number
  denominator: number
}

export interface FractionImproperToMixedChooseQuestionModel {
  question: FractionModel
  options: FractionModel[]
  correctAnswerIndex: number
  maxVariation: number
}

const DIFFICULTY_LEVEL_RANGE_MAP: DifficultyLevelRangeMapModel = {
  1: { numerator: { min: 2, max: 26 }, denominator: { min: 2, max: 5 }, variation: 80 },
  2: { numerator: { min: 5, max: 61 }, denominator: { min: 5, max: 20 }, variation: 600 },
  3: { numerator: { min: 10, max: 301 }, denominator: { min: 10, max: 50 }, variation: 1000 },
}

function generateImproperFraction(denominator: number, numeratorMax: number, excludes?: Set<string>): FractionModel {
  const numerator = getRandomInt(denominator + 1, numeratorMax)
  const quotient = 0
  const key = `${quotient}-${numerator}-${denominator}`
  if ((excludes && excludes.has(key)) || numerator % denominator === 0) {
    return generateImproperFraction(denominator, numeratorMax, excludes)
  }
  return { numerator, denominator, quotient }
}

function improperToMixed({ numerator, denominator }: FractionModel): FractionModel {
  return { quotient: Math.floor(numerator / denominator), numerator: numerator % denominator, denominator }
}

export function getFractionImproperToMixedChooseQuestionData(
  difficultyLevel: number,
  excludeFrac: string[],
): FractionImproperToMixedChooseQuestionModel {
  const excludes = new Set(excludeFrac)
  const range = DIFFICULTY_LEVEL_RANGE_MAP[difficultyLevel]
  let options: FractionModel[] = new Array<FractionModel>(4)
  const optionHistory = new Set<string>()
  const denominator = getRandomInt(range.denominator.min, range.denominator.max)
  // eslint-disable-next-line
  for (let i = 0; i < 4; i++) {
    const { quotient, numerator } = generateImproperFraction(denominator, range.numerator.max, optionHistory)
    optionHistory.add(`${quotient}-${numerator}-${denominator}`)
    options[i] = { quotient, numerator, denominator }
  }

  const correctAnswerIndex = getRandomInt(0, 3)
  const question: FractionModel = { ...options[correctAnswerIndex] }

  if (excludes.has(`${question.numerator}-${question.denominator}`)) {
    return getFractionImproperToMixedChooseQuestionData(difficultyLevel, excludeFrac)
  }
  options = options.map((o) => improperToMixed(o))
  return { question, options, correctAnswerIndex, maxVariation: range.variation }
}
